const constructQueryStringParams: ConstructQueryStringParamsType = (filter) => {
	const parsedQueryParams = JSON.parse(JSON.stringify(filter));

	return new URLSearchParams(parsedQueryParams).toString();
};

export default constructQueryStringParams;

type ConstructQueryStringParamsType = <T>(filter: T) => string;
